var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ui-image" }, [
    _c(
      "div",
      { staticClass: "item u-cover u-col", class: { active: _vm.success } },
      [
        _c("img", {
          attrs: { src: _vm.src },
          on: {
            load: function($event) {
              _vm.success = true
            },
            error: function($event) {
              _vm.error = true
            }
          }
        })
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "item u-cover u-col", class: { active: _vm.error } },
      [_c("icon-image")],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }